import React, { useEffect, useState } from "react";

import { useSelectedNode } from "components/WithExplainNodeSelection";
import NodeDetails from "components/ExplainNodeDetails";
import Source from "components/ExplainNodeSource";
import PillButtonBar from "components/PillButtonBar";

import { ExplainPlanType } from "utils/explain";

import { usePrevious } from "utils/hooks";
import ExplainStatsAndOptions from "components/ExplainStatsAndOptions";
import ExplainDisplayControls from "components/ExplainDisplayControls";
import { ExplainInsights } from "components/ExplainSidebarV2";
import { ComparablePlanType } from "components/WithExplainPlan";

const ExplainSidebar = ({
  explain,
  blockSize,
  plan,
  databaseId,
  summaryOnly,
  relatedWorkbookId,
}: {
  explain: ExplainPlanType;
  blockSize: number;
  plan: ComparablePlanType;
  databaseId: string;
  summaryOnly: boolean;
  relatedWorkbookId: string;
}) => {
  const [section, setSection] = useState<
    "summary" | "node details" | "node source"
  >("summary");
  const [selectedNode] = useSelectedNode();
  const selectedId = selectedNode?.extra.id;
  const previousSelectedId = usePrevious(selectedId);
  const switchToNodeDetails =
    !summaryOnly &&
    section === "summary" &&
    selectedId &&
    selectedId !== previousSelectedId;
  const opts = [
    { value: "summary", label: "Summary" },
    { value: "node details", label: "Node Details" },
    { value: "node source", label: "Node Source" },
  ] as const;
  const actualSection = summaryOnly ? "summary" : section;

  useEffect(() => {
    if (switchToNodeDetails) {
      setSection("node details");
    }
  }, [switchToNodeDetails]);
  return (
    <div>
      <PillButtonBar
        opts={opts.filter((opt) => !summaryOnly || opt.value === "summary")}
        selected={actualSection}
        onChange={(value) => setSection(value)}
      />
      <div className="mt-4">
        {actualSection === "summary" ? (
          <>
            <ExplainStatsAndOptions
              seenAt={explain.seenAt}
              fingerprint={explain.fingerprint}
              totCost={explain.totalCost}
              ioBlocks={explain.totalSharedBlksRead}
              ioMs={explain.totalBlkReadTime}
              plan={plan.plan.plan}
              runtime={explain.querySample?.runtimeMs}
              blockSize={blockSize}
            />
            <hr />
            <ExplainInsights
              databaseId={databaseId}
              queryId={explain.query.id}
              plan={plan}
              relatedWorkbookId={relatedWorkbookId}
            />
            <hr />
            <ExplainDisplayControls />
          </>
        ) : actualSection === "node details" ? (
          <NodeDetails
            databaseId={databaseId}
            blockSize={blockSize}
            plan={plan.plan}
          />
        ) : actualSection === "node source" ? (
          <Source />
        ) : null}
      </div>
    </div>
  );
};

export default ExplainSidebar;
